var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("table", { staticClass: "intrinsic-safety-table" }, [
      _c("tbody", [
        _c("tr", [
          _c("td", [
            _c("p", [
              _c("strong", [_vm._v("Uo:")]),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.node.location.type == "equipment"
                      ? _vm.node.location.equipmentDetail
                          ?.miscellaneousCertification?.apparatusUoV
                      : _vm.node.location.junctionBoxDetail
                          ?.miscellaneousCertification?.apparatusUoV
                  ) +
                  " "
              ),
            ]),
            _c("p", [
              _c("strong", [_vm._v("Io:")]),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.node.location.type == "equipment"
                      ? _vm.node.location.equipmentDetail
                          ?.miscellaneousCertification?.apparatusIoMa
                      : _vm.node.location.junctionBoxDetail
                          ?.miscellaneousCertification?.apparatusIoMa
                  ) +
                  " "
              ),
            ]),
            _c("p", [
              _c("strong", [_vm._v("Po:")]),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.node.location.type == "equipment"
                      ? _vm.node.location.equipmentDetail
                          ?.miscellaneousCertification?.apparatusPoW
                      : _vm.node.location.junctionBoxDetail
                          ?.miscellaneousCertification?.apparatusPoW
                  ) +
                  " "
              ),
            ]),
            _c("p", [
              _c("strong", [_vm._v("Co:")]),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.node.location.type == "equipment"
                      ? _vm.node.location.equipmentDetail
                          ?.miscellaneousCertification?.apparatusCouF
                      : _vm.node.location.junctionBoxDetail
                          ?.miscellaneousCertification?.apparatusCouF
                  ) +
                  " "
              ),
            ]),
            _c("p", [
              _c("strong", [_vm._v("Lo:")]),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.node.location.type == "equipment"
                      ? _vm.node.location.equipmentDetail
                          ?.miscellaneousCertification?.apparatusLoMh
                      : _vm.node.location.junctionBoxDetail
                          ?.miscellaneousCertification?.apparatusLoMh
                  ) +
                  " "
              ),
            ]),
          ]),
          _c("td", [
            _c("p", [
              _c("strong", [_vm._v("Ui:")]),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.node.location.type == "equipment"
                      ? _vm.node.location.equipmentDetail
                          ?.miscellaneousCertification?.fieldUiV
                      : _vm.node.location.junctionBoxDetail
                          ?.miscellaneousCertification?.fieldUiV
                  ) +
                  " "
              ),
            ]),
            _c("p", [
              _c("strong", [_vm._v("Ii:")]),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.node.location.type == "equipment"
                      ? _vm.node.location.equipmentDetail
                          ?.miscellaneousCertification?.fieldIiMa
                      : _vm.node.location.junctionBoxDetail
                          ?.miscellaneousCertification?.fieldIiMa
                  ) +
                  " "
              ),
            ]),
            _c("p", [
              _c("strong", [_vm._v("Pi:")]),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.node.location.type == "equipment"
                      ? _vm.node.location.equipmentDetail
                          ?.miscellaneousCertification?.fieldPiW
                      : _vm.node.location.junctionBoxDetail
                          ?.miscellaneousCertification?.fieldPiW
                  ) +
                  " "
              ),
            ]),
            _c("p", [
              _c("strong", [_vm._v("Ci:")]),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.node.location.type == "equipment"
                      ? _vm.node.location.equipmentDetail
                          ?.miscellaneousCertification?.fieldCiuF
                      : _vm.node.location.junctionBoxDetail
                          ?.miscellaneousCertification?.fieldCiuF
                  ) +
                  " "
              ),
            ]),
            _c("p", [
              _c("strong", [_vm._v("Li:")]),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.node.location.type == "equipment"
                      ? _vm.node.location.equipmentDetail
                          ?.miscellaneousCertification?.fieldLiMh
                      : _vm.node.location.junctionBoxDetail
                          ?.miscellaneousCertification?.fieldLiMh
                  ) +
                  " "
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }